(function() {
  var kolList = [{
    id: '1',
    name: 'nickolehaymaker',
    content: `There’s no better way to welcome the first official day of fall (even when it’s 90°) then in this @graecove linen dress! 🍁🍂 It’s no secret this is my favorite time of year and I hope it brings joy to you as well. I’m wishing everyone the best FALL SEASON YET! PS: temps are supposed to drop next week and I can’t wait!`,
    image: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ins_01_600x.jpg?v=1678445706',  
    insLink: 'https://www.instagram.com/p/Ci0oyfxAx9k/',
    productList: [{
      id: '6996642037808',
      color: 'Brown'
    }]
  }, {
    id: '2',
    name: 'kristenkhoff',
    content: `We are so happy about this beautiful spring weather! I got sunburned this week from working out in the garden, and I’m not even mad about it. Spending these days in linen, breathing in the sweet spring air with my babies. I am in heaven!`,
    image: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/output_1_46de9ab4-edc6-4bde-972f-c9d7db9c0df2_600x.jpg?v=1685092612',  
    insLink: 'https://www.instagram.com/p/Cr6MCYIOIDK/',
    productList: [{
      id: '6996642168880',
      color: 'Taupe'
    }]
  }, {
    id: '3',
    name: '_samreid',
    content: `don’t mind me I’ll just be living in this dress from @graecove for the rest of the spring/summer 🌞`,
    image: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/output_1854201c-5fd0-455a-b6b1-869113c51f31_600x.jpg?v=1685092644',  
    insLink: 'https://www.instagram.com/p/CsRmW26O86G/',
    productList: [{
      id: '6993881759792',
      color: 'Jasmine Yellow'
    }]
  }, {
    id: '4',
    name: 'sarah.cooper.worth',
    content: `Everyday linen pieces with the most beautiful details 🐚`,
    image: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/output_2_570a9299-6b6f-46be-8c5c-256abc94474d_600x.jpg?v=1685092696',  
    insLink: 'https://www.instagram.com/p/CsG-mdVoxkp/',
    productList: [{
      id: '7213207388208',
      color: 'Greyish Green'
    }]
  }, {
    id: '5',
    name: 'flockhartjodi',
    content: 
    `⛅️Weekend mood!
    Relaxing at home in @graecove
    Seriously the best linen range and so affordable. ..
    Happy weekend beautiful friends!
    xx`,
    image: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/337753142_205373135512360_433341135881513209_n_600x.jpg?v=1679648592',  
    insLink: 'https://www.instagram.com/p/Cp6VKipvPSv/',
    productList: [{
      id: '6995645792304',
      color: 'Blue'
    }, {
      id: '7192351965232',
      color: 'White'
    }]
  }, {
    id: '6',
    name: 'emily.lavinskas',
    content: 
    `Safe to say I think I found one of my new favourite brands?! Not only are they sustainable, but the pieces are so high-quality and at such a great price point for any budget. With warmer weather coming sooner than we think, #LinenClothing is sure to keep you cool all summer long.`,
    image: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ins_03_600x.jpg?v=1678445705',  
    insLink: 'https://www.instagram.com/p/Cn14Y_BA0jt/',
    productList: [{
      id: '7125114191920',
      color: 'White'
    }, {
      id: '6996642201648',
      color: 'Beige'
    }]
  }, {
    id: '7',
    name: 'euniceandradee',
    content: 
    `I'm always on the lookout for comfy chic clothes and think I've hit gold @graecove is not only super cute and affordable, but also extremely comfortable and breathable! Currently loving the Paige Smocked Maxi Dress for summer do you love it too?`,
    image: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/output_3567c7bc-24f0-43c7-8398-ff32a71369c1_600x.png?v=1685092818',  
    insLink: 'https://www.instagram.com/p/Cr1Ki4sum1L/',
    productList: [{
      id: '6993891721264',
      color: 'Pink'
    }]
  }, {
    id: '8',
    name: 'kateoyuna',
    content: 
    `I’m in love with this linen set lately🤍perfect fabric in summer days so breathable and comfortable yet stylish though 🥰

    Love @graecove sustainable and eco-friendly linen clothings.`,
    image: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/output_1_c883c740-4495-44ff-a493-1dc1963c5725_600x.png?v=1685092874',  
    insLink: 'https://www.instagram.com/p/CsGs8zDu9OU/',
    productList: [{
      id: '7192375853104',
      color: 'White'
    }]
  }];
  var isLoading = false;
  var kolDetailSlider = null;
  var kolProductItems = null;
  var curKolId = null;
  var curKolIndex = 0;
  var kolPopup = `
    <div class="kol-popup">
      <div class="kol-popup-overlay"></div>
      <div class="kol-popup-container">
        <div id="kol-popup_arrow-left" class="kol-popup_arrow-left disabled" />
        <div id="kol-popup_arrow-right" class="kol-popup_arrow-right" />
        <img id="kol-popup_close-icon" class="kol-popup_close-icon" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls_icon_close_2x_8dd0268d-87f9-44ba-839d-e97cfb0a0b4f.png?v=1678170031"/>
        <div class="kol-popup_slider-wrapper">
          <div class="kol-popup_slider-inner">
            <% for (var kolItem of data) { %>
              <div class="kol-details-box kol-details-box-<%= kolItem.id %>">
                <div class="kol-popup_images-wrapper">
                  <div class="kol-popup_image-item js-lazyload-img">
                    <div class="kol-popup_image-bg" style="background-image: url('<%= kolItem.image %>')"></div>
                    <img class="kol-popup_image" data-lazyload-src="<%= kolItem.image %>">
                  </div>
                </div> 
                <div class="kol-popup_right-wrapper">
                  <div class="kol-popup_info-wrapper">
                    <a class="kol-popup_name" href="<%= kolItem.insLink %>" target="_blank">@<%= kolItem.name %></a>
                    <div class="kol-popup_content"><%= kolItem.content %></div>
                  </div>
                  <div class="kol-popup_bottom-wrapper">
                    <div class="kol-popup_bottom-title">Get the Look</div>
                    <div class="kol-popup_product-wrapper">
                      <div class="ls-featured-collection-listing">
                        <div class="ls-featured-collection-product-list"></div>
                      </div>  
                    </div>
                  </div>
                </div>
              </div>
            <% } %>
          </div>
        </div>  
      </div>
    </div>
  `;
  var kolModuleHtml = `
    <% for (var kolItem of data) { %>
      <div class="looksky-kol-module_image-box kol-item" data-id="<%= kolItem.id %>">
        <div class="looksky-kol-module_image-mask">
          <p class="looksky-kol-module_image-mask-text">Get the look</p>
          <p class="looksky-kol-module_image-mask-name">@<%= kolItem.name %></p>
        </div>
        <div class="looksky-kol-module_image-item js-lazyload-img">
          <img class="looksky-kol-module_image" data-lazyload-src="<%= kolItem.image %>">
        </div>
      </div>
    <% } %>
  `;
  var kolFn = {
  bindEvent: function() {
    $(document).on('click', '.looksky-kol-module_image-wrapper .kol-item', function() {
      curKolId = $(this).attr('data-id');
      kolFn.handleKolData();
      LS.ui.homePageFn.homeComponentClickExposure(JSON.stringify({
        url: $(this).find('.looksky-kol-module_image').attr('src'),
      }), this);
    });

    $(document).on('click', '#kol-popup_close-icon', function() {
      $('.kol-popup').remove();
    });

    $(document).on('click', '#kol-popup_arrow-left', function() {
      var _this = $(this);
      if (_this.hasClass('disabled')) return;
      kolDetailSlider && kolDetailSlider.slideNext();
    });

    $(document).on('click', '#kol-popup_arrow-right', function() {
      var _this = $(this);
      if (_this.hasClass('disabled')) return;
      kolDetailSlider && kolDetailSlider.slidePrev();
    });
  },
  handleKolData: async function() {
    if (!kolProductItems) {
      await kolFn.getKolProductList();
    }
    var kolPopupArr = kolList.slice();
    var kolIndex = kolPopupArr.findIndex(item => item.id == curKolId);
    kolPopupArr = (kolPopupArr.splice(kolIndex,1)).concat(kolPopupArr);
    var kolPopupDom = LS.tmpl(kolPopup, kolPopupArr);
    $('body').append(kolPopupDom);
    kolFn.setKolProducts(kolPopupArr[0]);
    $('.kol-popup').show();
    kolDetailSlider = null;
    setTimeout(function() {
      kolDetailSlider = new LS.Slider({
        container: ".kol-popup_slider-wrapper",
        isLoop: false,
        endCallback: function(index) {
          curKolId = kolPopupArr[index].id;
          curKolIndex = index;
          if (curKolIndex === 0) {
            $('#kol-popup_arrow-left').addClass('disabled');
          } else if (curKolIndex === kolList.length - 1) {
            $('#kol-popup_arrow-right').addClass('disabled');
          } else {
            $('#kol-popup_arrow-left').removeClass('disabled');
            $('#kol-popup_arrow-right').removeClass('disabled');
          }
          var productBox = $(`.kol-details-box-${curKolId} .ls-featured-collection-product-list`);
          productBox.length && productBox.empty();
          setTimeout(function() {
            kolFn.setKolProducts(kolPopupArr[index]);
            LS.stat({
              eid: LS.ui.reportType['moduleShow'],
              ext1: LS.ui.homeReportMap['showKolModule'],
              ext4: `pos=${curKolId}`,
            });
          }, 300);
        }
      });
    }, 1000);

    LS.stat({
      eid: LS.ui.reportType['moduleShow'],
      ext1: LS.ui.homeReportMap['showKolModule'],
      ext4: `pos=${kolPopupArr[0].id}`,
    });
  },
  setKolProducts: function(kolData) {
    if (kolData) {
      var productArr = kolData.productList;
      for (var i = 0, len = kolProductItems.length; i < len; i++) {
        var kolItemDom = kolProductItems[i];
        var kolItem = $(kolItemDom);
        var kolProductId = kolItem.attr('data-product-id');
        var curKolProductItem = productArr.find(item => item.id == kolProductId);
        if (curKolProductItem) {
          $(kolItem).attr('data-kol-color', curKolProductItem.color);
          var targetDetailsBox = $(`.kol-details-box-${kolData.id}`);
          var innerBox = $(targetDetailsBox).find('.ls-featured-collection-product-list');
          innerBox.append(kolItem);
        }
      }
      kolFn.handleSkuColor();
    }
  },
  handleSkuColor: function() {
    var productDomList = $(`.kol-details-box-${curKolId}`).find('.ls-product-block');
    for(var i = 0, len = productDomList.length; i < len; i++) {
      var productDomItem = $(productDomList[i]);
      var kolColor = productDomItem.attr('data-kol-color');
      var variantHtml = productDomItem.find('.ls-product-variants-list').html().trim();
      if (variantHtml) {
        var variantsImageBox = productDomItem.find('.ls-variants-image-box');
        for (var j = 0, vLen = variantsImageBox.length; j < vLen; j++) {
          var variantsImageItem = $(variantsImageBox[j]);
          var variantColor = variantsImageItem.attr('data-value');
          var activeClassName = 'ls-variants-image-active';
          if (variantColor === kolColor) {
            var variantsImg = variantsImageItem.attr("data-img") || 'null';
            var imgLinkDom = productDomItem.find('.ls-product-link');
            variantsImageItem.addClass(activeClassName);
            var selectLink = imgLinkDom.attr('href');
            selectLink = selectLink.split('?')[0];
            imgLinkDom.attr('href', `${selectLink}?color=${kolColor}`);
            variantsImageItem.parents(".ls-product-block-innerbox").find('.shop-featured-img').attr('src', variantsImg);
          } else {
            variantsImageItem.removeClass(activeClassName);
          }
        }
      }
    }
  },
  insertKolModule: function() {
    var kolModuleDom = LS.tmpl(kolModuleHtml, kolList);
    $('.looksky-kol-module_image-wrapper').html(kolModuleDom);
    $('.looksky-kol-module').show();
  },
  getKolProductList: function() {
    if (isLoading) return;
    isLoading = true;
    return new Promise(function(resolve, reject) {
      LS.ajax({
        url: LS.ui.routes.getKolProducts,
        dataType: "html",
        success: function(res) {
          var responseHTML = JSON.parse(res || 'null')['looksky-kol-data'];
          kolProductItems = $($(responseHTML).find('.kol-product-list .ls-product-block'));
          isLoading = false;
          resolve();
        },
        error: function() {
          isLoading = false;
          reject();
        }
      })  
    });
  }
}

  function init() {
    setTimeout(function() {
      kolFn.insertKolModule();
      kolFn.bindEvent();
      kolFn.getKolProductList();
    }, 600);
  }

  init();
})();